import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiTriggers {
  static getTriggers(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/triggers`);
  }

  static updateTrigger(appId, triggerId, trigger) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/triggers/${triggerId}`, {
      method: "PUT",
      body: { trigger },
    });
  }

  static createTrigger(appId, trigger) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/triggers`, {
      method: "POST",
      body: { trigger },
    });
  }

  static async deleteTrigger(appId, triggerId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/triggers/${triggerId}`, {
      method: "DELETE",
    }).then(_ => triggerId);
  }

  static customEvents(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/custom_events`);
  }
}
